import { render, staticRenderFns } from "./GoBackTitle.vue?vue&type=template&id=0617358e&scoped=true&"
import script from "./GoBackTitle.vue?vue&type=script&lang=js&"
export * from "./GoBackTitle.vue?vue&type=script&lang=js&"
import style0 from "./GoBackTitle.vue?vue&type=style&index=0&id=0617358e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617358e",
  null
  
)

export default component.exports